export default {
  data() {
    return {
      text: 'abcdef12345',
      isInputted: true
    }
  },
  methods: {
    onFocus() {
      this.isInputted = true
    },
    onInput() {
      this.isInputted = this.text.length !== 0
    },
    onBlur() {
      this.isInputted = this.text.length !== 0
    },
    clearText() {
      this.text = ''
      this.isInputted = false
    }
  }
}
